<template>
  <section class="info-cards">

    <div class="info-cards__inner">
      <Heading
              class="font-bold"
              :label="`Your ${reservationState === 'upcoming' ? 'upcoming' : ''} stay${reservations.length > 1 ? 's' : ''}`"
              level="h4"
      />
<!-- Loader -->
      <loader v-if="loading" />
      <!-- No reservation -->
      <div v-if="!loading && reservationState === 'none'">
        No reservation at the moment
      </div>
      <!-- Upcoming or current reservation -->
      <Swiper
          v-if="!loading && (reservationState === 'upcoming' || reservationState === 'current')"
          ref="cardSwiper"
          class="info-cards__cards"
          :options="swiperOptions"
      >
        <SwiperSlide
            v-for="(r, index) in reservations"
            :key="`slide-${index}`"
            class="info-cards__slide"
        >
            <div class="info-cards__cards info-cards__slide">
              <div class="info-card info-card--date">
                <Label
                    class="font-bold"
                    :label="r.startDate.format('dddd')"
                />
                <p class="xlarge">
                  {{ r.startDate.format('DD') }}
                  <sub>{{ r.startDate.format('MMM') }}</sub>
                </p>
              </div>
              <div class="info-card info-card--date">
                <Label
                    class="font-bold"
                    :label="r.endDate.format('dddd')"
                />
                <p class="xlarge">
                  {{ r.endDate.format('DD') }}
                  <sub>{{ r.endDate.format('MMM') }}</sub>
                </p>
              </div>
              <Button
                  :title="buttonText(r.status)"
                  :icon-right="r.status === 'checked-in' ? '' : 'arrow-right'"
                  button-background="light"
                  button-color="dark"
                  @click.native="openCheckIn(r.id)"
              />
            </div>


        </SwiperSlide>
      </Swiper>
      <div v-show="reservations.length > 1" class="info-cards__pagination"></div>
      <portal to="root">
      <modal
              :open="openModal"
              @closeModal="() => openModal = !openModal"
              noPadding
              fullScreen
      >
        <SectionHeader :image="{url:'/img/thishostel/scribble-03.png'}" :title="buttonText(reservationInModel ? reservationInModel.status : undefined)" show_logo />
        <div v-if="reservationInModel && reservationInModel.status === 'ready-to-check-in'" class="checkin-wrapper">
          <h3>Check-in</h3>

          <h5>Check-in is just a scan away.</h5>

          <p style="margin-bottom: 40px">
            Scan this QR code when you arrive for a faster check-in or use this PIN code at the check in counter <b>{{ reservationInModel.number }}</b>
          </p>


          <qr-code class="qr-wrapper" :text="reservationInModel.qrData"></qr-code>


          <p>
            If you have any questions or need help with check-in, just ask one of our staff members.
          </p>
            <h5>
          Some details about your stay:
        </h5>
          <div class="details-wrapper">
            <SectionTable v-if="reservationInModelForDetail" :table-group="reservationInModelForDetail"></SectionTable>
          </div>
<!--          <p style="margin-top: 40px">-->
<!--          Need further assistance? Contact us via <a href="#" @click.stop.prevent="openChat()">chat</a>.-->
<!--        </p>-->
        </div>


        <div v-if="reservationInModel && reservationInModel.status === 'checked-in'" class="checkin-wrapper">
          <h3>YOUR CUBE</h3>
          <p style="margin-bottom: 40px">
            Need further assistance? Contact us via <a href="#" @click.stop.prevent="openChat()">chat</a>.
          </p>

            <h5>
          Some details about your stay:
        </h5>
          <div class="details-wrapper">
            <SectionTable v-if="reservationInModelForDetail" :table-group="reservationInModelForDetail"></SectionTable>
          </div>
          <p style="margin-bottom: 40px">

          </p>

          <p>
            Want to check out? Please use our tablet at the kiosk.
          </p>
          <!--          No mews rights fot the checkout at the moment
          <Button title="Checkout" @click.native="checkout" :loading="checkOutLoading"></Button>
          -->
        </div>


        <div v-if="reservationInModelForDetail && reservationInModelForDetail.status === 'checked-out'" class="checkin-wrapper">
          <h3>You are now checked out</h3>
          <p style="margin-bottom: 40px">
            Thank you for staying with us and we hope you had a pleasant stay.
          </p>


          <p style="margin-bottom: 40px">
            Need further assistance? Contact us via <a href="#" @click.stop.prevent="openChat()">chat</a>.
          </p>

        </div>

        <div v-if="reservationInModelForDetail && reservationInModelForDetail.status === 'canceled'" class="checkin-wrapper">
          <h3>It looks like your reservation is canceled</h3>
          <p style="margin-bottom: 40px">
            Need further assistance? Contact us via <a href="#" @click.stop.prevent="openChat()">chat</a>.
          </p>

        </div>


      </modal>
    </portal>
    </div>
  </section>
</template>

<script>
import Button from '@/components/partials/Button'
import dayjs from 'dayjs'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import Heading from '@/components/heading/Heading'
import Label from '@/components/partials/Label'
import Modal from '@/components/modals/Modal'
import Loader from '@/components/partials/Loader'
import SectionTable from '@/sections/section-table/SectionTable.vue'
import SectionHeader from '@/sections/section-header/SectionHeader'
import { EventBus, EVENTS } from '@/services/events/EventBus'
import { dateToDayMonthYearTime } from '@/filters/times'

export default {
  components: {
    Button,
    Heading,
    Label,
    Modal,
    Loader,
    SectionTable,
    SectionHeader,
    Swiper,
    SwiperSlide
  },
  computed: {
    loading () {
      return this.$store.state.reservations.loading
    },
    reservationState () {
      return this.$store.state.reservations.reservationState
    },
    reservationInModel () {
      return this.$store.state.reservations.reservationInModel
    },
    reservations () {
      return this.$store.state.reservations.reservations
    },
    isCheckedIn () {
      console.log('this.$store.getters.reservations.isCheckedIn', this.$store.getters['reservations/isCheckedIn'])
      return this.$store.getters['reservations/isCheckedIn']
    },
    checkInStatus () {
      console.log('this.$store.getters.reservations.checkInStatus', this.$store.getters['reservations/checkInStatus'])
      return this.$store.getters['reservations/checkInStatus']
    },
    reservationInModelForDetail () {
      const myBooking = this.$store.state.reservations.reservationInModel
      if (!myBooking) {
        return null
      }
      let links = [
        {
          title: 'Total guests',
          value: myBooking.totalGuests
        },
        {
          title: 'Check In',
          value: dateToDayMonthYearTime(myBooking.startDate)
        },
        {
          title: 'Check out',
          value: dateToDayMonthYearTime(myBooking.endDate)
        }
      ]
      if (myBooking.status === 'checked-in' && myBooking.cube) {
        links.unshift({
          title: 'Your cube',
          value: myBooking.cube
        })
      }
      return [{
        // title: 'Some details about your stay',
        links: links
      }]
    }
  },
  data () {
    return {
      openModal: false,
      startDate: new dayjs(),
      endDate: new dayjs().add(3, 'day'),
      checkOutLoading: false,
      swiperOptions: {
        init: true,
        pagination: {
          el: '.info-cards__pagination',
          type: 'bullets',
          clickable: true
        }
      }
    }
  },
  methods: {
    openCheckIn (reservationId) {
      this.$store.dispatch('reservations/setReservationInModal', reservationId)
      this.openModal = true
    },
    openChat () {
      this.openModal = false
      EventBus.$emit(EVENTS.OpenChat)
    },
    checkout() {
      if (confirm('Are you sure you want to check out')) {
        this.checkOutLoading = true
      }
    },
    buttonText (status) {
      switch (status) {
        case 'ready-to-check-in':
          return 'KIOSK Check in'
        case 'checked-in':
          return 'YOUR STAY'
        case 'checked-out':
          return 'Checked out'
      }
      return 'YOUR STAY'
    },
  },
  mounted () {
    this.$store.dispatch('reservations/getReservations')
  }
}
</script>

<style lang="scss" scoped>
.info-cards {
  position: relative;
  z-index: 1;
  padding: 0 $padding;
  margin-top: $info-cards-overlap;
  color: $info-cards-color;
  .heading {
    margin-top: 0;
    padding: 0;
  }
  &__inner {
    background: $info-cards-background;
    & > .meta,
    & > .heading {
      display: block;
      padding-bottom: $info-cards-padding;
    }
    @if $info-cards-space-around {
      padding: $info-cards-padding;
    }
    @else {
      & > .meta {
        padding: $info-cards-padding;
      }
      .info-cards__footer {
        padding: 0 $info-cards-padding $info-cards-padding;
      }
    }
  }
  &__slide {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  &__item {
    width: 50%;
  }
  &__pagination {
    display: flex;
    justify-content: $info-cards-bullets-align;
    width: 100%;
    .swiper-pagination-bullet {
      display: inline-block;
      margin: $info-cards-bullets-margin;
      background-color: $info-cards-bullets-inactive-color;
      opacity: 1;
    }
    .swiper-pagination-bullet-active {
      background-color: $info-cards-bullets-active-color;
    }
  }
  .button {
    margin-top: rem(20);
  }
}

  .info-card {
  position: relative;
  color: $info-cards-color;
  padding: $info-card-padding;
  border: $info-cards-border;
  width: 50%;
  &:nth-of-type(2n) {
    border-left: none;
  }
  &:nth-of-type(4n) {
    border-top: 0;
  }
  &:nth-of-type(4n) {
    border-top: 0;
    border-left: 0;
  }
  &--date {
    padding: $info-card-date-padding;
  }
  &__icon {
    width: $info-card-icon-size;
    height: $info-card-icon-size;
    margin-bottom: rem(10);
  }
  &__trigger {
    display: block;
    text-decoration: none;
    padding: 0;
    font-size: inherit;
    &:focus {
      outline: none;
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
}
</style>
<style lang="scss">
  .qr-wrapper img {
    margin: 0 auto;
  }
  .details-wrapper {
    table {
      margin-left: -0.9375rem;
    }
  }
  .checkin-wrapper {
    padding: $padding;
  }
</style>

<docs>
  ```vue
  <section-checkin />
  ```
</docs>
